<template>
    <component :is="component" :alarmData="alarmData"  v-if="component"/>

</template>

<script>
import {defineAsyncComponent} from "vue";

export default {
    name: "AlarmListLink",
    mixins: [],
    components: {},
    provide() {
        return {}
    },
    props: {
        listLayout: {},
        alarmData: {type: Array, default: () => {return []}},
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
        // this.listLoader();
    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {
        component() {
            if (!this.listLayout) {
                return defineAsyncComponent(() => import('@/components/alarm/layout/list/AlarmListDefaultLayout.vue'))
            }
            return defineAsyncComponent(() => import(`@/components/alarm/layout/list/${this.listLayout}.vue`))
        },
    },
    methods: {
    },
    watch: {},
}
</script>

<style scoped>

</style>
